import React, { useState } from 'react';
import authService from '../../services/authService';
import { navigateToStaffRoute } from '../../utils/nativeNavigation';
import { LEGAL } from '../../config/legal';
import { SITE_CONFIG } from '../../config/siteConfig';
import AuthPageLayout from '../AuthPageLayout/AuthPageLayout';
import './PartnerSetup.css';

const PartnerLegalAccept: React.FC = () => {
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!acceptTerms) {
      setError('You must accept the Terms & Conditions and Privacy Policy to continue.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await authService.acceptPartnerLegal(true);
      if (response.success) {
        await navigateToStaffRoute(response.redirectUrl || '/dashboard');
        return;
      }
      setError(response.message || 'Could not save your acceptance. Please try again.');
    } catch (err: unknown) {
      const axiosErr = err as { response?: { data?: { message?: string } } };
      setError(axiosErr.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageLayout>
      <div className="partner-setup-container">
        <div className="partner-setup-wrapper">
          <div className="partner-setup-form">
            <h2 className="partner-setup-title">Review and accept</h2>
            <p className="partner-setup-subtitle">
              Peppar Enterprises updated its Terms &amp; Conditions and Privacy Policy (version{' '}
              {LEGAL.documentVersion}). Restaurant owners must accept them before using the staff
              console.
            </p>
            {error && (
              <div className="error-message" role="alert">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="partner-consent">
                <input
                  id="acceptTerms"
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                  required
                />
                <label htmlFor="acceptTerms">
                  I am authorised to bind this restaurant. I have read and agree to the{' '}
                  <a
                    href={`${SITE_CONFIG.urls.site}/terms-and-conditions`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms &amp; Conditions
                  </a>{' '}
                  and{' '}
                  <a
                    href={`${SITE_CONFIG.urls.site}/privacy-policy`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>{' '}
                  of Peppar Enterprises (version {LEGAL.documentVersion}).
                </label>
              </div>
              <div className="step-actions step-actions--end">
                <button type="submit" className="btn-primary" disabled={loading || !acceptTerms}>
                  {loading ? 'Saving...' : 'Agree and continue'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default PartnerLegalAccept;
